<template>
  <b-popover
    v-if="showPopOver && target"
    :target="target"
    ref="popover"
    triggers="focus"
    :placement="placement"
    title="This action is not allowed because you're not verified yet."
  >
    <div class="text-center">
      <b-button
        ref="button"
        size="sm"
        @click="resendVerification"
      >
        Resend Link
      </b-button>
    </div>
  </b-popover>
</template>

<script>
import userVerificationMixin from '@/components/utils/verification/verification';


export default {
  name: 'verificationUserEmail',
  props: {
    target: {
      type: String,
      required: true,
    },
    placement: {
      type: String,
      default: 'left',
    },
  },
  mixins: [userVerificationMixin],
  mounted() {
    this.$root.$on('bv::popover::show', (event) => {
      if (event.target.id === this.target && this.$refs.button) {
        this.$nextTick().then(() => {
          this.$refs.button.focus();
        });
      }
    });
  },
  computed: {
    isVerified() {
      try {
        return this.$store.getters.user.verified;
      } catch (_) {
        return false;
      }
    },
    showPopOver() {
      return !this.isVerified;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/utils/verification/VerificationUserEmail.vue